import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import IconLock from '@pkg/assets/images/Lock.png';
import { CircleButton, YatMagnetism } from '@pkg/components';
import { DepButton, DepButtonDisplay } from '@pkg/components/deprecated';
import { useAppDispatch, useMobile } from '@pkg/hooks';

import { handleKeyDown } from '@app/helpers';
import { hide2faRequirePopup, show2faSetupFlow } from '@app/store/slices';

import YatFooterV2 from '../../Footer/Footer';

import './LoginPopup.scss';

export const TwoFactorAuthRequirePopup = () => {
    const { isMobile } = useMobile();
    const { t } = useTranslation(['twoFactorAuth']);
    const dispatch = useAppDispatch();

    const onClosePopup = () => {
        dispatch(hide2faRequirePopup());
    };

    const onShowAuthSetup = () => {
        dispatch(hide2faRequirePopup());
        dispatch(show2faSetupFlow());
    };

    return (
        <div className="two-factor-login-popup">
            <YatMagnetism classes="yat-picker-back-button">
                <CircleButton onClick={onClosePopup} ariaLabel={t('common:back_to_previous_page')} size="large">
                    <CloseIcon className="page-top-bar__icon" />
                </CircleButton>
            </YatMagnetism>

            <div className="two-factor-login-popup__container">
                <div className="two-factor-login-popup__container-content">
                    <div className="two-factor-login-popup__icon">
                        <img src={IconLock} alt="lock" />
                    </div>
                    <h2
                        className="two-factor-login-popup__title"
                        dangerouslySetInnerHTML={{ __html: t('2fa_title') }}
                    />
                    <p
                        className="two-factor-login-popup__instruction"
                        dangerouslySetInnerHTML={{ __html: t('2fa_instruction') }}
                    />
                    <div className="two-factor-login-popup__submit">
                        <DepButton display={isMobile ? DepButtonDisplay.block : undefined} onClick={onShowAuthSetup}>
                            {t('2fa_submit_cta')}
                        </DepButton>
                    </div>
                    <div>
                        <div
                            tabIndex={0}
                            aria-label={t('2fa_cancel_cta')}
                            className="two-factor-login-popup__cancel"
                            onClick={onClosePopup}
                            onKeyDown={(e) => handleKeyDown(e, ['Enter', ' '], onClosePopup)}
                        >
                            {t('2fa_cancel_cta')}
                        </div>
                    </div>
                </div>
            </div>
            <YatFooterV2 />
        </div>
    );
};
